import React, { useEffect, useMemo, useRef, useState } from "react";
import "./JobsDashboard.css"
import Section from "../../../../components/base/Section";
import JobsBoardActions from "../components/JobsBoardActions";
import { isGridViewEnabled, useRememberJobsBoard } from "../utils/jobsBoardState";
import JobsFilterBar from "../components/JobsFilterBar";
import { setBoardListWidth, useBoardSettings } from "../utils/jobsBoardSettings";
import { jobMatchesKeyword } from "../utils/jobFilters";
import JobsBoardIndexRail, { IndexRailItem, IndexRailMode } from "../components/JobsBoardIndexRail";
import Layout from "../../../../components/layouts/Layout";
import TapToPayBanner from "../../../../components/taptopay/TapToPayBanner";
import { sortJobStatuses, canManageJobs, createJob, editJob, getUser, hasRole, openCloseJob, openEditJobAddress, openEditJobAppt, openEditJobTech, openInvalidCloseJob, openJobQuickView, openReopenJob, openSendJob, setMobileToolbar, setPage, setToolbarActions, setToolbarComponent, useEnsureChats, useEnsureJobs, useEnvironment, useGlobal, useHub, useJobMetros, useJobs, useJobTypes, useScreen, useSocket, useStatuses } from "../../../../core/Global";
import { API_ROUTES } from "../../../../core/Constants";
import Icon from "../../../../components/base/Icon";
import FlexRow from "../../../../components/base/FlexRow";
import Modal from "../../../../components/base/Modal";
import Job from "../models/Job";
import { FilterItem } from "../../../../components/data/Filtering";
import JobNotesModal from "../components/JobNotesModal";
import JobUpdateStatusModal from "../components/jobmodals/JobUpdateStatusModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import JobTasksModal from "../components/jobmodals/JobTasksModal";
import JobUpdateStatusNoteDrawer from "../components/jobmodals/JobUpdateStatusNoteDrawer";
import JobsBulkStatusDrawer from "../components/jobmodals/JobsBulkStatusDrawer";
import { SortTypes, UserTypes } from "../../../../core/Enums";
import JobStatus from "../../base/models/JobStatus";
import JobSendTechRespondModal from "../components/jobmodals/JobSendTechRespondModal";
import JobAttachmentsModal from "../components/jobmodals/JobAttachmentsModal";
import JobAppointmentModal from "../components/jobmodals/JobAppointmentModal";
import { GroupedVirtuoso, GroupedVirtuosoHandle } from "react-virtuoso";
import JobDataFullCardHead from "../components/JobDataFullCardHead";
import JobDataFullCard from "../components/JobDataFullCard";
import DropdownMenu, { MenuItem } from "../../../../components/menu/DropdownMenu";
import DataItem from "../../../../models/DataItem";
import Indicator from "../../../../components/base/Indicator";
import JobDataCard from "../components/JobDataCard";
import { isNativeiOSApp } from "../../../../NativeAppBrdige";


interface ISortRows {
    id?: string
    sortKey?: string
    sortType?: SortTypes
}

export interface JobStatusRow {
    rowType: string
    status: JobStatus
}


function isJobStatusRow(item: any): item is JobStatusRow {
    return item.rowType === "JobStatusRow";
}

export default function JobsNewBoard(props: { grid?: boolean }) {

    const hub = useHub()
    const env = useEnvironment()
    const screen = useScreen()
    const statuses = useStatuses()
    const jobsBank = useJobs()

    // Jobs are the board's data; the chat list only feeds the per-card chat badges, but it's
    // a lightweight summary payload so the board pulls it too. Both no-op once loaded.
    useEnsureJobs()
    useEnsureChats()
    useRememberJobsBoard()

    const user = getUser()

    const navigate = useNavigate()

    const [boxHeight, boxHeightSet] = useState<number>();

    // Floating "back to top" button, shown once the list is scrolled well down.
    const virtuosoRef = useRef<GroupedVirtuosoHandle>(null);
    const [showBackToTop, showBackToTopSet] = useState<boolean>(false);
    // The group at the top of the list, for the thumb index.
    const [activeGroup, activeGroupSet] = useState<number>(0);
    // While a tab's smooth jump is running, the groups it passes must not light up one by one:
    // the picked tab stays active until the list reaches it (or the jump's time is up -- the
    // last groups can't scroll to the top, so they may never be "reached").
    const indexJumpRef = useRef<{ target: number, until: number }>();
    // Height of the whole list: the thumb index only shows when the list actually scrolls.
    const [listHeight, listHeightSet] = useState<number>(0);
    const jobMetros = useJobMetros();
    const boardSettings = useBoardSettings();

    const fixSizes = () => {
        var w = $(window).width() ?? 500;
        var h = $(window).height() ?? 400;
        h = h - ($("#kt_header").outerHeight() ?? 50);
        h = h - ($("#kt_toolbar").outerHeight() ?? 0);
        // On mobile the tab bar floats (glass) so the board runs full height and
        // scrolls under it; a Virtuoso footer spacer keeps the last card reachable.
        // On desktop the board runs from its own top edge to the bottom of the window.
        const box = boxRef.current;
        if (!screen.isMobile && box) h = window.innerHeight - (box.getBoundingClientRect().top + window.scrollY);
        else h = h - (screen.isMobile ? 0 : 80);
        boxHeightSet(h);
    }

    useEffect(() => {

        fixSizes();
        window.addEventListener("resize", fixSizes);




        return () => {
            window.removeEventListener("resize", fixSizes);
        }

    }, [])




    const [globalState, globalStateSet] = useGlobal()

    const [, setSearchParams] = useSearchParams();

    const [compact, compactSet] = useState<boolean>(false)

    useEffect(() => {
        if (screen.width < 1500) compactSet(true)
        else compactSet(false)
    }, [screen])


    // const addQueryParam = (key: string, value: string | string[]) => {
    //     const params = new URLSearchParams(window.location.search);

    //     if (Array.isArray(value)) {
    //         if (value.length === 0) {
    //             params.delete(key);
    //         } else {
    //             params.set(key, value.join(","));
    //         }
    //     } else {
    //         params.set(key, value);
    //     }

    //     navigate({ search: params.toString() });
    // }

    // Each group's column sort rides in the address (?sort=groupId~key~a|d,...) like the filters,
    // so it survives leaving the board and coming back.
    const [sortModel, sortModelSet] = useState<ISortRows[]>(() =>
        (new URLSearchParams(window.location.search).get("sort") ?? "").split(",").filter(Boolean).map(part => {
            const [id, sortKey, dir] = part.split("~");
            return { id: id || undefined, sortKey, sortType: dir == "d" ? SortTypes.Descending : SortTypes.Ascending };
        }).filter(s => !!s.sortKey));
    const [filtering, filteringSet] = useState<boolean>();

    const [job, jobSet] = useState<Job>();

    const [statusAction, statusActionSet] = useState<JobStatus>();
    //const [selectedStatus, selectedStatusSet] = useState<JobStatus>()

    const [formReset, formResetSet] = useState<boolean>(false);

    const [filterItems, filterItemsSet] = useState<FilterItem[]>([]);
    const [filterJobTypes, filterJobTypesSet] = useState<string[]>([]);
    const [filterJobSources, filterJobSourcesSet] = useState<string[]>([]);
    const [filterFlags, filterFlagsSet] = useState<string[]>([]);
    const [filterTags, filterTagsSet] = useState<string[]>([]);
    const [filterMetros, filterMetrosSet] = useState<string[]>([]);
    const [filterTechs, filterTechsSet] = useState<string[]>([]);

    const [filterHasCall, filterHasCallSet] = useState<string>();
    const [filterHasNewCall, filterHasNewCallSet] = useState<string>();

    useEffect(() => {
        const jobTypes = filterItems.filter(f => f.name == "jobTypes").map(f => (f.value?.value ?? ""));
        filterJobTypesSet(jobTypes);

        const jobSources = filterItems.filter(f => f.name == "jobSources").map(f => (f.value?.value ?? ""));
        filterJobSourcesSet(jobSources);

        const flags = filterItems.filter(f => f.name == "flags").map(f => (f.value?.value ?? ""));
        filterFlagsSet(flags);

        const tags = filterItems.filter(f => f.name == "tags").map(f => (f.value?.value ?? ""));
        filterTagsSet(tags);

        const metros = filterItems.filter(f => f.name == "metros").map(f => (f.value?.value ?? ""));
        filterMetrosSet(metros);

        const techs = filterItems.filter(f => f.name == "techs").map(f => (f.value?.value ?? ""));
        filterTechsSet(techs);

        const hasCall = filterItems.filter(f => f.name == "hasCall").map(f => (f.value?.value ?? ""));
        if (hasCall.length > 0) filterHasCallSet(hasCall[0])
        else filterHasCallSet(undefined)

        const hasNewCall = filterItems.filter(f => f.name == "hasNewCall").map(f => (f.value?.value ?? ""));
        if (hasNewCall.length > 0) filterHasNewCallSet(hasNewCall[0])
        else filterHasNewCallSet(undefined)

    }, [filterItems])


    const [updateStatus, updateStatusSet] = useState<boolean>(false);
    const [updateStatusNote, updateStatusNoteSet] = useState<boolean>(false);


    const [updateAppointmentStatus, updateAppointmentStatusSet] = useState<boolean>(false);
    const [viewJobNotes, viewJobNotesSet] = useState<boolean>(false);
    const [viewJobTasks, viewJobTasksSet] = useState<boolean>(false);

    const [manageTechResponse, manageTechResponseSet] = useState<boolean>(false);

    const [inProgErrModal, inProgErrModalSet] = useState<boolean>(false);
    const [inProgErrText, inProgErrTextSet] = useState<string>("");






    const [groupBy, groupBySet] = useState<string>("status");
    // The header's applied filters, as one predicate (see utils/jobFilters).
    const [boardFilter, boardFilterSet] = useState<(job: Job) => boolean>()



    const JobsGrouping = () => {
        return <JobsFilterBar
            mode="list"
            onGroupByChange={id => groupBySet(id)}
            onKeywordChange={findKeywordSet}
            // A function in state must be set through an updater, or React would call it.
            onFilterChange={f => boardFilterSet(() => f)}
        />
    }

    const JobBoardAction = () => {
        return <JobsBoardActions />
    }


    const MobileToolbar = () => {

        const canAddJob = user?.isTech ? hasRole("TechCreateJob") : canManageJobs()

        return (
            <FlexRow>
                {
                    canAddJob &&
                    <div className="board-add-job-btn" onClick={() => createJob()}>
                        <Icon icon="plus" type="solid" size={17} />
                    </div>
                }
            </FlexRow>
        )
    }

    useEffect(() => {

        setPage(screen.isMobile ? "Board" : "Jobs Board", "CRM", "Jobs");
        setToolbarComponent(JobsGrouping)
        setToolbarActions(JobBoardAction)

        setMobileToolbar(MobileToolbar)

        if (!hasRole("HasCRM")) {
            document.location.href = "/dashboard";
        }


        return () => {
            setToolbarComponent(undefined)
            setToolbarActions(undefined)
            setMobileToolbar(undefined)
        };
    }, [])

    useEffect(() => {

        if (formReset) {
            setTimeout(() => {
                formResetSet(false);
            }, 1000);
        }

    }, [formReset])

    const [openAttachments, openAttachmentsSet] = useState<boolean>(false);
    useEffect(() => {
        if (openAttachments) {
            window.openModal("modal-job-attachments");
        }
    }, [openAttachments])



    // Clicking a column title cycles that group's sort: ascending -> descending -> off.
    // A different column in the same group starts again at ascending.
    const sort = (id?: string, key?: string) => {
        sortModelSet(model => {
            const current = model.find(s => s.id == id);
            const rest = model.filter(s => s.id != id);
            if (!current || current.sortKey != key) return [...rest, { id, sortKey: key, sortType: SortTypes.Ascending }];
            if (current.sortType == SortTypes.Ascending) return [...rest, { id, sortKey: key, sortType: SortTypes.Descending }];
            return rest;
        });
    }

    // Sets a group's sort outright (the grid view's sort menu); no key clears it.
    const setSort = (id?: string, key?: string, sortType?: SortTypes) => {
        sortModelSet(model => {
            const rest = model.filter(s => s.id != id);
            return key ? [...rest, { id, sortKey: key, sortType: sortType ?? SortTypes.Ascending }] : rest;
        });
    }

    useEffect(() => {
        const value = sortModel
            .filter(s => !!s.sortKey)
            .map(s => `${s.id ?? ""}~${s.sortKey}~${s.sortType == SortTypes.Descending ? "d" : "a"}`)
            .join(",");
        // Read fresh, like JobsFilterBar: several params can change in quick succession.
        const next = new URLSearchParams(window.location.search);
        if (value) next.set("sort", value);
        else next.delete("sort");
        if (next.toString() !== new URLSearchParams(window.location.search).toString())
            setSearchParams(next, { replace: true });
    }, [sortModel])


    const SortIcon = (props: { sortKey: string, id: string }) => {

        const active = () => {
            for (var i = 0; i < sortModel.length; i++) {
                var s = sortModel[i];
                if (s.id == props.id && s.sortKey == props.sortKey) return true;
            }
            return false;
        }

        const acsending = () => {
            for (var i = 0; i < sortModel.length; i++) {
                var s = sortModel[i];
                if (s.id == props.id && s.sortKey == props.sortKey && s.sortType == SortTypes.Ascending) return true;
            }
            return false;
        }
        return (
            <>
                {
                    active() ?
                        <Icon icon={acsending() ? "sort-down" : "sort-up"} type="solid" />
                        : <></>
                }
            </>
        )
    }

    const jobsFilter = (job: Job) => {
        var res: Array<boolean> = [];

        if (boardFilter) res.push(boardFilter(job));


        if (filterJobTypes.length > 0) res.push(job.jobTypeId != null && filterJobTypes.includes(job.jobTypeId));
        if (filterJobSources.length > 0) res.push(job.jobSourceId != null && filterJobSources.includes(job.jobSourceId));
        if (filterFlags.length > 0) res.push(job.flagIds != null && job.flagIds.length > 0 && job.flagIds.some(fl => filterFlags.includes(fl)));
        if (filterTags.length > 0) res.push(job.tagIds != null && job.tagIds.length > 0 && job.tagIds.some(tg => filterTags.includes(tg)));
        if (filterMetros.length > 0) res.push(job.metroId != null && filterMetros.includes(job.metroId));
        if (filterTechs.length > 0) res.push(job.techId != null && filterTechs.includes(job.techId));

        if (filterHasCall && filterHasCall == "True") res.push(job.jobCalls && job.jobCalls.length > 0 ? true : false);
        if (filterHasCall && filterHasCall == "False") res.push(job.jobCalls && job.jobCalls.length > 0 ? false : true);

        if (filterHasNewCall && filterHasNewCall == "True") res.push(job.jobCalls && job.jobCalls.length > 0 && job.jobCalls.filter(f => f.isCompleted && (f.listeners?.length ?? 0) < 1).length > 0 ? true : false);
        if (filterHasNewCall && filterHasNewCall == "False") res.push(job.jobCalls && job.jobCalls.length > 0 && job.jobCalls.filter(f => f.isCompleted && (f.listeners?.length ?? 0) < 1).length > 0 ? false : true);

        if (findKeyword) res.push(jobMatchesKeyword(job, findKeyword));

        return res.every(f => f);
    }

    const jobsSort = (a: Job, b: Job, groupId?: string) => {

        var srow = sortModel.filter(v => v.id == groupId)[0];
        if (srow?.sortKey == "jobId") {
            if (srow?.sortType == SortTypes.Ascending) return (new Date(a.lastStatusUpdatedAt!).getTime()) - (new Date(b.lastStatusUpdatedAt!).getTime());
            else return (new Date(b.lastStatusUpdatedAt!).getTime()) - (new Date(a.lastStatusUpdatedAt!).getTime());
        }
        if (srow?.sortKey == "type") {
            if (srow?.sortType == SortTypes.Ascending) return ((a.jobType ?? "") > (b.jobType ?? "")) ? 1 : ((b.jobType ?? "") > (a.jobType ?? "")) ? -1 : 0;
            else return ((a.jobType ?? "") > (b.jobType ?? "")) ? -1 : ((b.jobType ?? "") > (a.jobType ?? "")) ? 1 : 0;
        }
        if (srow?.sortKey == "source") {
            if (srow?.sortType == SortTypes.Ascending) return ((a.jobSource ?? "") > (b.jobSource ?? "")) ? 1 : ((b.jobSource ?? "") > (a.jobSource ?? "")) ? -1 : 0;
            else return ((a.jobSource ?? "") > (b.jobSource ?? "")) ? -1 : ((b.jobSource ?? "") > (a.jobSource ?? "")) ? 1 : 0;
        }
        if (srow?.sortKey == "name") {
            if (srow?.sortType == SortTypes.Ascending) return ((a.fullName ?? "") > (b.fullName ?? "")) ? 1 : ((b.fullName ?? "") > (a.fullName ?? "")) ? -1 : 0;
            else return ((a.fullName ?? "") > (b.fullName ?? "")) ? -1 : ((b.fullName ?? "") > (a.fullName ?? "")) ? 1 : 0;
        }
        if (srow?.sortKey == "phone") {
            if (srow?.sortType == SortTypes.Ascending) return ((a.phone?.phone ?? "") > (b.phone?.phone ?? "")) ? 1 : ((b.phone?.phone ?? "") > (a.phone?.phone ?? "")) ? -1 : 0;
            else return ((a.phone?.phone ?? "") > (b.phone?.phone ?? "")) ? -1 : ((b.phone?.phone ?? "") > (a.phone?.phone ?? "")) ? 1 : 0;
        }
        if (srow?.sortKey == "address") {
            if (srow?.sortType == SortTypes.Ascending) return ((a.address?.title ?? "") > (b.address?.title ?? "")) ? 1 : ((b.address?.title ?? "") > (a.address?.title ?? "")) ? -1 : 0;
            else return ((a.address?.title ?? "") > (b.address?.title ?? "")) ? -1 : ((b.address?.title ?? "") > (a.address?.title ?? "")) ? 1 : 0;
        }
        if (srow?.sortKey == "metro") {
            if (srow?.sortType == SortTypes.Ascending) return ((a.metroName ?? "") > (b.metroName ?? "")) ? 1 : ((b.metroName ?? "") > (a.metroName ?? "")) ? -1 : 0;
            else return ((a.metroName ?? "") > (b.metroName ?? "")) ? -1 : ((b.metroName ?? "") > (a.metroName ?? "")) ? 1 : 0;
        }
        if (srow?.sortKey == "tech") {
            if (srow?.sortType == SortTypes.Ascending) return ((a.tech?.fullName ?? "") > (b.tech?.fullName ?? "")) ? 1 : ((b.tech?.fullName ?? "") > (a.tech?.fullName ?? "")) ? -1 : 0;
            else return ((a.tech?.fullName ?? "") > (b.tech?.fullName ?? "")) ? -1 : ((b.tech?.fullName ?? "") > (a.tech?.fullName ?? "")) ? 1 : 0;
        }
        if (srow?.sortKey == "appointment") {
            const aTime = getDateTime(a);
            const bTime = getDateTime(b);

            if (aTime == null && bTime == null) return 0;
            if (aTime == null) return 1;
            if (bTime == null) return -1;

            return (srow?.sortType == SortTypes.Ascending) ? aTime - bTime : bTime - aTime;

        }
        if (srow?.sortKey == "modified") {
            const aTime = a.modifiedAt ? new Date(a.modifiedAt).getTime() : 0;
            const bTime = b.modifiedAt ? new Date(b.modifiedAt).getTime() : 0;
            return (srow?.sortType == SortTypes.Ascending) ? aTime - bTime : bTime - aTime;
        }
        if (srow?.sortKey == "created" || srow?.sortKey == "statusChange") {
            const at = (j: Job) => {
                const d = srow?.sortKey == "created" ? j.createdAt : j.lastStatusUpdatedAt;
                return d ? new Date(d).getTime() : 0;
            };
            return (srow?.sortType == SortTypes.Ascending) ? at(a) - at(b) : at(b) - at(a);
        }
        if (srow?.sortKey == "localTime") {
            // Local time order is the timezone offset order; jobs without a timezone go last.
            const aOff = a.stateId && a.timezone ? a.timezoneOffset : undefined;
            const bOff = b.stateId && b.timezone ? b.timezoneOffset : undefined;
            if (aOff == null && bOff == null) return 0;
            if (aOff == null) return 1;
            if (bOff == null) return -1;
            return (srow?.sortType == SortTypes.Ascending) ? aOff - bOff : bOff - aOff;
        }
        return (new Date(b.lastStatusUpdatedAt!).getTime()) - (new Date(a.lastStatusUpdatedAt!).getTime())
    }

    const getDateTime = (item: Job): number | undefined => {
        if (!item.appointmentDate) return undefined;

        try {
            const dateString = item.appointmentDate.split('/').reverse().join('-');
            const timeString = item.appointmentTimeFrom || '00:00';
            const fullString = `${dateString}T${timeString}`;
            const date = new Date(fullString);

            if (isNaN(date.getTime())) {
                return undefined;
            }

            return date.getTime();
        } catch {
            return undefined;
        }
    }

    const [groupItems, groupItemsSet] = useState<DataItem[]>([]);
    // The grouping groupItems were built for. groupBy changes a render before the effect below
    // rebuilds the groups, so the thumb index reads this one to never pair the new mode with the
    // old groups (e.g. a metro name drawn as a technician avatar).
    const [groupedBy, groupedBySet] = useState<string>("status");
    const [groupCounts, groupCountsSet] = useState<number[]>([]);
    const [groupedJobs, groupedJobsSet] = useState<Job[]>([]);

    const [findKeyword, findKeywordSet] = useState<string>();

    // Multi-select for bulk actions (desktop, dispatchers only).
    const [selectedIds, selectedIdsSet] = useState<string[]>([]);
    const [bulkStatusOpen, bulkStatusOpenSet] = useState<boolean>(false);

    // Statuses in their database order, fetched directly so the board can order
    // the status groups reliably even when the socket-fed global list is empty.
    const [statusesDb, statusesDbSet] = useState<JobStatus[]>([]);
    useEffect(() => {
        hub.Get(API_ROUTES.JobStatuses + "all", res => {
            if (res.success && res.data) statusesDbSet(res.data);
        });
    }, []);

    // Derived, NOT mirrored into state through an effect. As state it stayed `undefined` whenever
    // the board mounted before the jobs arrived: `globalState.jobsFetched` is read live from the
    // store and flips to true, but the effect that filled `jobs` had already run and nothing
    // re-triggered it — so neither the spinner branch (jobsFetched false) nor the list branch
    // (jobs set) rendered and the board came up blank until it was remounted.
    const jobs = useMemo(
        () => jobsBank?.filter(jobsFilter),
        [jobsBank, findKeyword, boardFilter])

    useEffect(() => {
        window.dataTableMenu()
    }, [jobs])

    useEffect(() => {

        if (!jobs) return;

        if (groupBy == "status" && jobs) {


            const jobStatuses: DataItem[] = Array.from(
                jobs.reduce<Map<string, DataItem>>((acc, job) => {
                    const key = `${job.jobStatusId}_${job.jobStatus?.name}`;
                    const existing = acc.get(key);

                    if (existing) {
                        existing.count = (existing.count || 0) + 1;
                    } else {
                        acc.set(key, {
                            id: job.jobStatusId,
                            name: job.jobStatus?.name,
                            color: job.jobStatus?.color,
                            icon: "circle",
                            count: 1,
                        });
                    }

                    return acc;
                }, new Map()).values()
            ).sort((a, b) => {
                // Order groups by the statuses' database order. Prefer the live
                // global list; fall back to the directly-fetched one when it's empty.
                // The account's manual order, asked for here: the global list arrives in
                // whichever order its path happened to produce.
                const orderRef = sortJobStatuses(statuses.length > 0 ? statuses : statusesDb);
                // A status missing from the reference list goes LAST. findIndex returns -1 for
                // it, and -1 sorted straight to the very top -- so one unknown status silently
                // became the first column instead of the least important one.
                const rank = (id?: string) => {
                    const i = orderRef.findIndex(s => s.id === id);
                    return i < 0 ? Number.MAX_SAFE_INTEGER : i;
                };
                return rank(a.id) - rank(b.id);
            });

            const gcount = jobStatuses.map(status =>
                jobs.filter(job => job.jobStatusId === status.id).length
            )
            const gjobs = jobStatuses.flatMap(st =>
                jobs.filter(job => job.jobStatusId === st.id).sort((a, b) => jobsSort(a, b, st.id))
            )

            groupItemsSet(jobStatuses);
            groupCountsSet(gcount);
            groupedJobsSet(gjobs);
        }

        if (groupBy == "type" && jobs) {

            const jobTypes: DataItem[] = Array.from(
                jobs.reduce<Map<string, DataItem>>((acc, job) => {
                    const key = `${job.jobTypeId}_${job.jobType}`;
                    const existing = acc.get(key);

                    if (existing) {
                        existing.count = (existing.count || 0) + 1;
                    } else {
                        acc.set(key, {
                            id: job.jobTypeId,
                            name: job.jobType,
                            icon: "wrench",
                            count: 1,
                        });
                    }

                    return acc;
                }, new Map()).values()
            ).sort((a, b) => (b.count ?? 0) - (a.count ?? 0));

            const gcount = jobTypes.map(f =>
                jobs.filter(job => job.jobTypeId === f.id).length
            )

            const gjobs = jobTypes.flatMap(f =>
                jobs.filter(job => job.jobTypeId === f.id).sort((a, b) => jobsSort(a, b, f.id))
            )

            groupItemsSet(jobTypes);
            groupCountsSet(gcount);
            groupedJobsSet(gjobs);
        }

        if (groupBy == "source" && jobs) {

            const jobSources: DataItem[] = Array.from(
                jobs.reduce<Map<string, DataItem>>((acc, job) => {
                    const key = `${job.jobSourceId}_${job.jobSource}`;
                    const existing = acc.get(key);

                    if (existing) {
                        existing.count = (existing.count || 0) + 1;
                    } else {
                        acc.set(key, {
                            id: job.jobSourceId,
                            name: job.jobSource,
                            icon: "bullhorn",
                            count: 1,
                        });
                    }

                    return acc;
                }, new Map()).values()
            ).sort((a, b) => (b.count ?? 0) - (a.count ?? 0));

            const gcount = jobSources.map(f =>
                jobs.filter(job => job.jobSourceId === f.id).length
            )

            const gjobs = jobSources.flatMap(f =>
                jobs.filter(job => job.jobSourceId === f.id).sort((a, b) => jobsSort(a, b, f.id))
            )

            groupItemsSet(jobSources);
            groupCountsSet(gcount);
            groupedJobsSet(gjobs);
        }

        if (groupBy == "metro" && jobs) {

            const jobMetros: DataItem[] = Array.from(
                jobs.reduce<Map<string, DataItem>>((acc, job) => {
                    const key = `${job.metroId}_${job.metroName}`;
                    const existing = acc.get(key);

                    if (existing) {
                        existing.count = (existing.count || 0) + 1;
                    } else {
                        acc.set(key, {
                            id: job.metroId,
                            name: job.metroName,
                            icon: "map",
                            count: 1,
                        });
                    }

                    return acc;
                }, new Map()).values()
            ).sort((a, b) => (b.count ?? 0) - (a.count ?? 0));

            const gcount = jobMetros.map(f =>
                jobs.filter(job => job.metroId === f.id).length
            )

            const gjobs = jobMetros.flatMap(f =>
                jobs.filter(job => job.metroId === f.id).sort((a, b) => jobsSort(a, b, f.id))
            )

            groupItemsSet(jobMetros);
            groupCountsSet(gcount);
            groupedJobsSet(gjobs);
        }

        if (groupBy == "tech" && jobs) {

            const jobTechs: DataItem[] = Array.from(
                jobs.reduce<Map<string, DataItem>>((acc, job) => {
                    const key = `${job.techId}_${job.tech?.fullName}`;
                    const existing = acc.get(key);

                    if (existing) {
                        existing.count = (existing.count || 0) + 1;
                    } else {
                        acc.set(key, {
                            id: job.techId,
                            name: job.tech?.fullName,
                            icon: "user-helmet-safety",
                            count: 1,
                        });
                    }

                    return acc;
                }, new Map()).values()
            ).sort((a, b) => (b.count ?? 0) - (a.count ?? 0));

            const gcount = jobTechs.map(f =>
                jobs.filter(job => job.techId === f.id).length
            )

            const gjobs = jobTechs.flatMap(f =>
                jobs.filter(job => job.techId === f.id).sort((a, b) => jobsSort(a, b, f.id))
            )

            groupItemsSet(jobTechs);
            groupCountsSet(gcount);
            groupedJobsSet(gjobs);
        }

        groupedBySet(groupBy);

    }, [jobs, statuses, statusesDb, groupBy, sortModel])

    // A new grouping starts from the top of the list, not where the last one was scrolled to.
    useEffect(() => {
        indexJumpRef.current = undefined;
        activeGroupSet(0);
        virtuosoRef.current?.scrollTo({ top: 0 });
    }, [groupedBy])



    const toggleSelect = (id?: string) => {
        if (!id) return;
        selectedIdsSet(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    }
    const clearSelection = () => selectedIdsSet([]);
    const selectedJobs = (jobsBank ?? []).filter(j => j.id != null && selectedIds.includes(j.id));

    // Grid view: cards are laid out in lines of `gridColumns`, and each line is one virtualised item,
    // so the board keeps its grouping and virtualisation. Mobile always shows its own cards.
    const gridMode = !!props.grid && !screen.isMobile && isGridViewEnabled();
    // Bulk selection is the list view's only; grid cards have no checkbox.
    const canBulkSelect = !user?.isTech && !screen.isMobile && !gridMode;
    // Desktop: the board's scroll area runs edge to edge (scrollbar at the window edge); the side
    // gutter is padding on the lists inside the scroller (.board-virtuoso-padded), not the
    // container's margin -- padding the scroller itself narrows the sticky group header.
    const boardPadLeft = screen.isMobile ? 0 : 44, boardPadRight = screen.isMobile ? 0 : 30;
    const boxRef = useRef<HTMLDivElement>(null);
    const [boxWidth, boxWidthSet] = useState<number>(0);
    useEffect(() => {
        if (!boxRef.current) return;
        const ro = new ResizeObserver(entries => boxWidthSet(entries[0].contentRect.width));
        ro.observe(boxRef.current);
        return () => ro.disconnect();
        // The box only exists once the jobs are in: re-run when it appears, or it is never
        // measured (the grid then had one column and the list fell back to the window width).
    }, [gridMode, globalState.jobsFetched, !jobs, jobs?.length == 0]);

    // Re-measure once the board box exists (its top edge sets the desktop height).
    useEffect(() => {
        fixSizes();
    }, [globalState.jobsFetched, jobs?.length == 0]);

    const indexRailMode: IndexRailMode = groupedBy == "tech" ? "avatar" : groupedBy == "type" || groupedBy == "source" ? "letter" : groupedBy == "metro" ? "colorLetter" : "color";
    const indexRailGroups: IndexRailItem[] = groupItems.map(g => ({
        id: g.id,
        name: g.name,
        count: g.count,
        color: groupedBy == "status" ? g.color : groupedBy == "metro" ? jobMetros.find(m => m.id == g.id)?.color : undefined,
        avatarUrl: groupedBy == "tech" ? groupedJobs.find(j => j.techId == g.id)?.tech?.avatarUrl : undefined,
    }));

    // The list's columns split this width (see jobsBoardSettings' smart widths).
    useEffect(() => {
        if (boxWidth > 0) setBoardListWidth(boxWidth - boardPadLeft - boardPadRight);
    }, [boxWidth, boardPadLeft, boardPadRight]);

    // Denser boards fit narrower cards (more on a line); comfortable ones wider.
    const GRID_CARD_MIN = boardSettings.density == "compact" ? 220 : boardSettings.density == "comfortable" ? 300 : 260, GRID_GAP = 8;
    const gridColumns = Math.max(1, Math.floor((boxWidth - boardPadLeft - boardPadRight + GRID_GAP) / (GRID_CARD_MIN + GRID_GAP)));
    const grid = useMemo(() => {
        const counts: number[] = [];
        const rows: Job[][] = [];
        let start = 0;
        groupCounts.forEach(c => {
            const groupJobs = groupedJobs.slice(start, start + c);
            start += c;
            const lines = Math.ceil(c / gridColumns);
            counts.push(lines);
            for (let i = 0; i < lines; i++) rows.push(groupJobs.slice(i * gridColumns, (i + 1) * gridColumns));
        });
        return { counts, rows };
    }, [groupCounts, groupedJobs, gridColumns]);

    return (
        <Layout wide fitToolbar={!screen.isMobile} paddingTop={screen.isMobile ? undefined : 4} paddingBottom={screen.isMobile ? undefined : 0}>

            <TapToPayBanner />

            {
                !globalState.jobsFetched &&
                <Section fluid>
                    <div className="text-center my-20">
                        <Indicator />
                    </div>
                </Section>
            }

            {
                globalState.jobsFetched && jobs &&
                <>
                    {
                        jobs.length == 0 ?
                            <Section>
                                <div>
                                    <div>
                                        <div className="card-px text-center pt-15 pb-15">
                                            <h2 className="fs-2x fw-bolder mb-10">There are no active jobs.</h2>
                                            {
                                                user?.userType != UserTypes.Technician &&
                                                <div>
                                                    <button type="button" className="btn btn-primary" onClick={e => {
                                                        createJob();
                                                    }}>
                                                        Create New Job
                                                    </button>
                                                </div>
                                            }

                                        </div>
                                        <div className="text-center pb-15 px-5">
                                            <img src="/assets/media/illustrations/sketchy-1/16.png" alt="" className="mw-100 h-200px h-sm-325px" />
                                        </div>
                                    </div>
                                </div>
                            </Section>
                            :
                            <Section fluid fit={!screen.isMobile}>
                                <div ref={boxRef} className={`board-tint-${boardSettings.rowTint} board-density-${boardSettings.density}`}
                                    style={{ height: boxHeight, position: "relative" }}>

                                    {
                                        canBulkSelect && selectedIds.length > 0 &&
                                        <FlexRow className="jobs-bulk-bar" style={{
                                            position: "absolute",
                                            top: 12,
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            zIndex: 6,
                                            background: "var(--bs-body-bg)",
                                            boxShadow: "0 6px 24px rgba(0,0,0,0.18)",
                                            borderRadius: 999,
                                            padding: "8px 10px 8px 18px",
                                            border: "1px solid var(--bs-border-color)"
                                        }}>
                                            <span className="fw-bold fs-7 me-4 text-nowrap">
                                                {selectedIds.length} selected
                                            </span>
                                            <button type="button" className="btn btn-sm btn-primary me-2"
                                                onClick={() => bulkStatusOpenSet(true)}>
                                                <Icon icon="arrow-right-arrow-left" className="me-1" />
                                                Change Status
                                            </button>
                                            <button type="button" className="btn btn-sm btn-light"
                                                onClick={clearSelection}>
                                                Clear
                                            </button>
                                        </FlexRow>
                                    }

                                    <GroupedVirtuoso
                                        ref={virtuosoRef}
                                        className={screen.isMobile ? undefined : "board-virtuoso-padded"}
                                        overscan={200}
                                        onScroll={e => showBackToTopSet((e.target as HTMLElement).scrollTop > 800)}
                                        totalListHeightChanged={listHeightSet}
                                        rangeChanged={r => {
                                            // startIndex counts items only; walk the group sizes to find its group.
                                            const counts = gridMode ? grid.counts : groupCounts;
                                            let n = 0, g = 0;
                                            while (g < counts.length - 1 && r.startIndex >= n + counts[g]) n += counts[g++];
                                            const jump = indexJumpRef.current;
                                            if (jump && g != jump.target && Date.now() < jump.until) return;
                                            indexJumpRef.current = undefined;
                                            activeGroupSet(g);
                                        }}
                                        components={{
                                            Footer: () => (
                                                <div style={{
                                                    height: screen.isMobile ? (isNativeiOSApp() ? 120 : 100) : 50
                                                }} />
                                            )
                                        }}
                                        groupCounts={gridMode ? grid.counts : groupCounts}
                                        groupContent={i => (
                                            // No margin here: Virtuoso can't see a child's margin (it collapses
                                            // out of the item it measures), so the board's total height came out
                                            // short and the list kept correcting itself at the bottom. The gap
                                            // between groups is padding on each group's last item instead.
                                            <div>
                                                <JobDataFullCardHead
                                                    showTitles={!screen.isMobile && !gridMode}
                                                    selectable={canBulkSelect}
                                                    group={groupItems[i]}
                                                    sort={sortModel.find(s => s.id == groupItems[i].id)}
                                                    sortMenu={gridMode}
                                                    onSort={k => {
                                                        sort(groupItems[i].id, k)
                                                    }}
                                                    onSetSort={(k, t) => setSort(groupItems[i].id, k, t)} />
                                            </div>
                                        )}
                                        itemContent={(index, groupIndex) => {
                                            const job = groupedJobs[index];

                                            // The 30px gap before the next group, as padding (which Virtuoso measures).
                                            const counts = gridMode ? grid.counts : groupCounts;
                                            const groupEnd = counts.slice(0, groupIndex + 1).reduce((a, b) => a + b, 0) - 1;
                                            const gapAfter = index == groupEnd && groupIndex < counts.length - 1 ? 30 : 0;

                                            if (screen.isMobile) {
                                                return (
                                                    <div style={{ paddingBottom: gapAfter || undefined }}>
                                                    <JobDataCard key={"job-data-row-" + job.id} job={job}
                                                        onQuickView={job => openJobQuickView(job.id)}
                                                        onUpdateAddress={job => openEditJobAddress(job)}
                                                        onUpdateTech={job => openEditJobTech(job)}
                                                        onUpdateAppointment={job => openEditJobAppt(job)}
                                                        onUpdateStatusAppointment={job => {
                                                            jobSet(job);
                                                            updateAppointmentStatusSet(true);
                                                        }}
                                                        onUpdateStatus={job => {
                                                            jobSet(job);
                                                            updateStatusSet(true);
                                                        }}
                                                        onUpdateStatusNote={(job, st) => {
                                                            jobSet(job)
                                                            statusActionSet(st)
                                                            updateStatusNoteSet(true)
                                                        }}
                                                        onSendJob={job => {
                                                            jobSet(job);
                                                            openSendJob(job);
                                                        }}
                                                        onManageTechResponse={(job, s) => {
                                                            jobSet(job);
                                                            manageTechResponseSet(true);
                                                        }}
                                                        onViewNotes={job => openJobQuickView(job.id, "2")}
                                                        onOpenAttachments={job => {
                                                            jobSet(job);
                                                            openAttachmentsSet(true);
                                                        }}
                                                        onViewTasks={job => {
                                                            jobSet(job);
                                                            viewJobTasksSet(true);
                                                        }}
                                                        onEdit={job => {
                                                            editJob(job);
                                                        }}
                                                        onInProgressError={err => {
                                                            jobSet(job);
                                                            inProgErrModalSet(true);
                                                            inProgErrTextSet(err);
                                                        }}
                                                        onCloseJob={(job, callback) => {
                                                            hub.Get(API_ROUTES.Jobs + "validateclosing/" + job.id, res => {
                                                                if (res.data) {
                                                                    openCloseJob(job)
                                                                    callback();
                                                                }
                                                                else {
                                                                    openInvalidCloseJob(job, res.message)
                                                                    callback()
                                                                }
                                                            })
                                                        }}
                                                        onReopenFromClosed={(job, st) => {
                                                            openReopenJob(job, st)
                                                        }} />
                                                    </div>
                                                )
                                            }

                                            const fullCard = (job: Job, layout: "row" | "card") => (
                                                <JobDataFullCard key={"job-data-row-" + job.id} job={job} layout={layout}
                                                    showStatusName={groupedBy != "status"}
                                                    onQuickView={job => openJobQuickView(job.id)}
                                                    onUpdateAddress={job => openEditJobAddress(job)}
                                                    onUpdateTech={job => openEditJobTech(job)}
                                                    onUpdateAppointment={job => openEditJobAppt(job)}
                                                    onUpdateStatusAppointment={job => {
                                                        jobSet(job);
                                                        updateAppointmentStatusSet(true);
                                                    }}
                                                    onUpdateStatus={job => {
                                                        jobSet(job);
                                                        updateStatusSet(true);
                                                    }}
                                                    onUpdateStatusNote={(job, st) => {
                                                        jobSet(job)
                                                        statusActionSet(st)
                                                        updateStatusNoteSet(true)
                                                    }}
                                                    onSendJob={job => {
                                                        jobSet(job);
                                                        openSendJob(job);
                                                    }}
                                                    onManageTechResponse={(job, s) => {
                                                        jobSet(job);
                                                        manageTechResponseSet(true);
                                                    }}
                                                    onViewNotes={job => openJobQuickView(job.id, "2")}
                                                    onOpenAttachments={job => {
                                                        jobSet(job);
                                                        openAttachmentsSet(true);
                                                    }}
                                                    onViewTasks={job => {
                                                        jobSet(job);
                                                        viewJobTasksSet(true);
                                                    }}
                                                    onEdit={job => {
                                                        editJob(job);
                                                    }}
                                                    onInProgressError={err => {
                                                        jobSet(job);
                                                        inProgErrModalSet(true);
                                                        inProgErrTextSet(err);
                                                    }}
                                                    onCloseJob={(job, callback) => {
                                                        hub.Get(API_ROUTES.Jobs + "validateclosing/" + job.id, res => {
                                                            if (res.data) {
                                                                openCloseJob(job)
                                                                callback();
                                                            }
                                                            else {
                                                                openInvalidCloseJob(job, res.message)
                                                                callback()
                                                            }
                                                        })
                                                    }}
                                                    onReopenFromClosed={(job, st) => {
                                                        openReopenJob(job, st)
                                                    }}
                                                    selectable={canBulkSelect}
                                                    selected={job.id != null && selectedIds.includes(job.id)}
                                                    selectionMode={selectedIds.length > 0}
                                                    onToggleSelect={() => toggleSelect(job.id)} />
                                            );

                                            if (gridMode) {
                                                return (
                                                    <div className="jobs-grid-row"
                                                        style={{ gridTemplateColumns: `repeat(${gridColumns}, minmax(0, 1fr))`, paddingBottom: gapAfter || undefined }}>
                                                        {grid.rows[index]?.map(j => fullCard(j, "card"))}
                                                    </div>
                                                );
                                            }

                                            return gapAfter ? <div style={{ paddingBottom: gapAfter }}>{fullCard(job, "row")}</div> : fullCard(job, "row");
                                        }}
                                    />

                                    {
                                        // Thumb index (desktop): status and metro tabs carry their colour, technicians
                                        // their avatar, type and source a first letter.
                                        !screen.isMobile && groupItems.length > 1 && !!boxHeight && listHeight > boxHeight &&
                                        <JobsBoardIndexRail mode={indexRailMode} groups={indexRailGroups} active={activeGroup}
                                            onPick={i => {
                                                indexJumpRef.current = { target: i, until: Date.now() + 2500 }
                                                activeGroupSet(i)
                                                virtuosoRef.current?.scrollToIndex({ groupIndex: i, align: "start" })
                                            }} />
                                    }

                                    {
                                        showBackToTop &&
                                        <a href="#" className="board-back-to-top" title="Back to top"
                                            style={{ bottom: screen.isMobile ? (isNativeiOSApp() ? 130 : 110) : 24 }}
                                            onClick={e => {
                                                e.preventDefault()
                                                virtuosoRef.current?.scrollTo({ top: 0, behavior: "smooth" })
                                            }}>
                                            <Icon icon="arrow-up" type="solid" size={14} />
                                        </a>
                                    }
                                </div>

                            </Section>
                    }
                </>
            }






            {
                updateAppointmentStatus && job &&
                <JobAppointmentModal job={job} forceUpdateStatus
                    onClose={() => updateAppointmentStatusSet(false)} />
            }

            {
                updateStatus &&
                <JobUpdateStatusModal job={job}
                    onClose={() => updateStatusSet(false)} />
            }

            {
                bulkStatusOpen && selectedJobs.length > 0 &&
                <JobsBulkStatusDrawer jobs={selectedJobs}
                    onClose={() => bulkStatusOpenSet(false)}
                    onDone={clearSelection} />
            }

            {
                updateStatusNote &&
                <JobUpdateStatusNoteDrawer job={job} status={statusAction}
                    onClose={() => updateStatusNoteSet(false)} />
            }


            {
                viewJobNotes &&
                <JobNotesModal job={job}
                    onClose={() => viewJobNotesSet(false)} />
            }

            {
                viewJobTasks &&
                <JobTasksModal job={job}
                    onClose={() => viewJobTasksSet(false)} />
            }


            {
                manageTechResponse &&
                <JobSendTechRespondModal job={job}
                    onClose={() => manageTechResponseSet(false)} />
            }

            {
                openAttachments &&
                <JobAttachmentsModal job={job}
                    onClose={() => openAttachmentsSet(false)} />
            }


            {
                inProgErrModal &&
                <Modal id="modal-closejob-inprognotvalid"
                    title="Warning"
                    subtitle={"Job ID: " + job?.jobId + " | " + job?.fullName}
                    open visible
                    onClose={() => inProgErrModalSet(false)}>
                    <div>
                        <div className="mb-2 fw-bolder">Before update the job status to In Progress you should: </div>
                        <div className="bg-light-warning p-5"
                            style={{
                                whiteSpace: "pre"
                            }}>
                            {inProgErrText}
                        </div>
                    </div>
                </Modal>
            }

        </Layout>
    )
}
